import { ComponentProps } from 'react'

import BaseSvg from './BaseSvg'

type ChevronLeftIconProps = Partial<ComponentProps<typeof BaseSvg>>

const ChevronLeftIcon = ({ title = 'Back', ...rest }: ChevronLeftIconProps) => (
  <BaseSvg viewBox="0 0 12 12" title={title} {...rest}>
    <path
      d="M8.625.219A1,1,0,0,0,7.219.375l-4,5a1,1,0,0,0,0,1.25l4,5a1,1,0,0,0,1.562-1.25L5.281,6l3.5-4.375A1,1,0,0,0,8.625.219Z"
      fill="currentColor"
    ></path>
  </BaseSvg>
)

ChevronLeftIcon.displayName = 'ChevronLeft'
export default ChevronLeftIcon
